module.exports = __webpack_public_path__ + "img/interaction.ad7ec399.svg";